// Module
var code = "<div class=\"dms-grid-outer-wrapper dms-outer-element\">\r\n    <div class=\"dms-grid-wrapper dms-grid #=data.GridName#\"></div>\r\n</div>\r\n";
// Exports
export default code;